export default __webpack_public_path__ + "static/media/frame.0754c4a3.svg";